/**
 * 菜单数据服务
 * 处理菜单相关的API请求
 */

import menuConfig from "../router/menuConfig"

const menuService = {
  getMenuItems: () => menuConfig,
}

export default menuService
